import { cn } from '@virginexperiencedays/tailwind';
import { CSSProperties } from 'react';

type Props = {
  aspectRatio?: string;
  isMinimal?: boolean;
};

export const ProductCardSkeleton = ({ aspectRatio = '1/1', isMinimal }: Props) => {
  return (
    <div
      className={cn(
        'flex h-full rounded',
        isMinimal
          ? 'flex-row gap-2 md:flex-col'
          : 'border-border-neutral flex-col gap-1 border shadow-sm'
      )}
    >
      <div
        data-testid="image-container"
        className={cn(
          'aspect-[var(--aspectRatio)] shrink-0 animate-pulse rounded bg-[#aaa] md:basis-[unset]',
          isMinimal && 'basis-[120px]'
        )}
        style={
          {
            '--aspectRatio': aspectRatio,
          } as CSSProperties
        }
      />
      <div
        className={cn(
          'relative flex animate-pulse flex-col rounded',
          isMinimal && 'w-1/2',
          !isMinimal && 'px-2 pb-2 md:w-auto md:px-2 md:pb-0 md:pt-2'
        )}
        data-testid="content-container"
      >
        <div className="mb-2 mt-1 h-4 w-4/5 w-[80%] bg-[#aaa]" data-testid="title" />
        <div className="h-4 w-3/5 bg-[#aaa]" data-testid="location-text" />
        <div className="mt-1 h-4 w-9/12 bg-[#aaa]" data-testid="reviews-summary" />
        <div
          className={cn('mb-2 h-4 w-1/2 bg-[#aaa]', isMinimal ? 'mt-4' : 'mt-6')}
          data-testid="price"
        />
      </div>
    </div>
  );
};
